import React, { createContext, useContext, useState, useEffect } from 'react';
import i18next from "i18next";
import { DEFAULT_LANGUAGE } from 'constants/languages.constants'; 

export const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    i18next.changeLanguage(language); // Ensure i18next is updated
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};